/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseControl from './BaseControl.vue';

const __vue_script__ = {
    name: 'PasswordReset',

    components: { BaseInput },

    extends: BaseControl,

    props: {
        name: {
            type: String,
            default: 'password-confirmation'
        },

        value: {
            type: String,
            default: ''
        },

        passwordLabel: {
            type: String,
            required: true
        },

        confirmLabel: {
            type: String,
            required: true
        },

        passwordPlaceholder: {
            type: String,
            default: null
        },

        confirmPlaceholder: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            pass: {
                newPassword: '',
                passwordConfirm: ''
            },
            zxcvbn: null,
            strengthKeys: ['very_weak', 'weak', 'good', 'strong', 'good_job'],
            touchedConfirm: false
        };
    },

    computed: {
        /**
         * Is password too short
         */
        tooShort() {
            return this.pass.newPassword.length && this.pass.newPassword.length < this.$const.MIN_PASSWORD_LENGTH;
        },

        /**
         * Password strength
         */
        strength() {
            return this.zxcvbn && this.pass.newPassword.length ? this.zxcvbn(this.pass.newPassword).score : -1;
        },

        /**
         * Translated label for password strength
         */
        strengthLabel() {
            if (this.tooShort) {
                return this.$i18n.t('login.errors.short_password', [this.$const.MIN_PASSWORD_LENGTH]);
            }
            const key = this.strengthKeys[this.strength];

            return key ? this.$i18n.t(`profile.details.strength.${key}`) : '';
        },

        /**
         * Class for password strength label
         */
        strengthClass() {
            if (this.tooShort) {
                return 'very_weak';
            }
            return this.strengthKeys[this.strength] || '';
        },

        /**
         * Check that pass and confirmed pass are the same
         */
        confirmationMismatch() {
            return this.touchedConfirm && this.pass.passwordConfirm !== this.pass.newPassword;
        }
    },

    watch: {
        value(newValue) {
            this.pass.newPassword = newValue;
        }
    },

    async mounted() {
        this.zxcvbn = await System.import(`${window.BSTG.extLibs}/zxcvbn.js`);
    },

    methods: {
        onChange() {
            this.touchedConfirm = true;
            if (this.pass.newPassword === this.pass.passwordConfirm) {
                this.$emit('input', this.pass.newPassword);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{staticClass:"password-confirmation form-group",attrs:{"uid":_vm.uid,"dependant":_vm.dependant}},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":_vm.passwordLabel},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.passwordLabel,"placeholder":_vm.passwordPlaceholder,"type":"password","name":"newPassword","errors":errors,"autocomplete":"new-password"},model:{value:(_vm.pass.newPassword),callback:function ($$v) {_vm.$set(_vm.pass, "newPassword", $$v)},expression:"pass.newPassword"}}),_c('p',{staticClass:"password-strength",class:_vm.strengthClass},[_vm._v(_vm._s(_vm.strengthLabel))])]}}])}),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":_vm.confirmLabel},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.confirmLabel,"placeholder":_vm.confirmPlaceholder,"type":"password","name":"passwordConfirm","errors":errors,"autocomplete":"new-password"},on:{"input":_vm.onChange},model:{value:(_vm.pass.passwordConfirm),callback:function ($$v) {_vm.$set(_vm.pass, "passwordConfirm", $$v)},expression:"pass.passwordConfirm"}}),(_vm.confirmationMismatch)?_c('p',{staticClass:"password-confirmation-mismatch"},[_vm._v(_vm._s(_vm.$t('login.errors.password_confirmation_mismatch')))]):_vm._e()]}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PasswordConfirmation.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__